export type ModelDependencies = {
  id: string;
  dependencies: {
    contentTypes: string[];
    components: string[];
    tagGroups: string[];
    defaults: [string, string][];
    nodes: ([string] | [string, string])[];
  };
  dependencyOf: { contentTypes?: string[]; components?: string[] };
};
